import React from "react";
import BudgetBaseComponent from "../bases/BudgetBaseComponent/BudgetBaseComponent"
export default function BudgetsPage() { return <BudgetBaseComponent />; }
